import { InspectionAnalysisFlights, 
  InspectionAnalysisGeneric, 
  InspectionAnalysisGeometries,
  InspectionAnalysisGeometry} from './../../model/inspectionAnalysisInterface';
import { RootState } from '../../app/store';
import { openToast } from '../../utility/toast';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { InspectionAnalisysHistoryJob, InspectionAnalysisData, InspectionAnalysisState } from 
  '../../model/inspectionAnalysisInterface';
import { fetchData, fetchjobHistoryDetail, getTypeFromrunId } 
  from '../../services/inspectionAnalysisAPI';


const initialDataState: any = {

  layer: [],
  flights: [],
  defects: []
};

const initialState: InspectionAnalysisState = {
  analysis: {
    data: initialDataState,
    status: 'idle'
  }
};

export const listDataAsync = createAsyncThunk(
  'inspectionAnalysis/listData',
  async (ctx: string) => {
    try {
      const response = await fetchData(ctx);

      

      return response;
    } catch (e: any) {
      openToast({
        severity: 'error',
        alertMessage: e?.data?.errorMessage ?? 'FetchKO'
      });
      return Promise.reject(e.data ? e.data : e);
    }
  }
);


export const inspectionAnalysisSlice = createSlice({
  name: 'inspectionAnalysis',
  initialState,
  reducers: {
    resetlistDefects: (state) => {
      state.analysis.status = 'idle';
      state.analysis.data = initialDataState;
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(listDataAsync.pending, (state) => {
        state.analysis.status = 'loading';
      })
      .addCase(listDataAsync.fulfilled, (state, action) => {
        state.analysis.status = 'success';
        state.analysis.data = action.payload;
      })
      .addCase(listDataAsync.rejected, (state: any, action) => {
        state.analysis.status = 'failed';
        state.analysis.data = action.error;
      });

  }
});
export const {
  resetlistDefects
} = inspectionAnalysisSlice.actions;

export const listDefectsState = (state: RootState) =>
  state.inspectionAnalysis.analysis;


export default inspectionAnalysisSlice.reducer;
